import { DisplayMode, Engine, vec } from 'excalibur';
import { CONFIG } from './config';
import { loader } from './resources';
import { Level } from './level';

export const score = {
  gifts: 0,
  total: 0,
  timer: 0,
  currentLevel: CONFIG.firstLevel,
} as const;

const game = new Engine({
  width: CONFIG.screen.width * CONFIG.scale,
  height: CONFIG.screen.height * CONFIG.scale,
  canvasElementId: 'canvas',
  pixelArt: true,
  physics: {
    gravity: vec(0, CONFIG.physics.gravity),
  },
  scenes: {
    start: Level,
  },
  displayMode: DisplayMode.Fixed,
  // physics: {
  //   solver: SolverStrategy.Realistic,
  //   substep: 5 // Sub step the physics simulation for more robust simulations
  // },
  // fixedUpdateTimestep: 16 // Turn on fixed update timestep when consistent physic simulation is important
});

game
  .start('start', {
    // name of the start scene 'start'
    loader, // Optional loader (but needed for loading images/sounds)
    // inTransition: new FadeInOut({
    //   // Optional in transition
    //   duration: 1000,
    //   direction: "in",
    //   color: Color.ExcaliburBlue,
    // }),
  })
  .then(() => {
    // Do something after the game starts
  });
